import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import type { SubscriptionStatus } from '../types'

export function useQuerySubscriptionStatus(companyId: string | null | undefined) {
  return useQuery<SubscriptionStatus>({
    queryKey: ['subscription.status', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<SubscriptionStatus>(
        `/config-api/${companyId}/subscription/status`,
      )
      return data
    },
    enabled: !!companyId,
    staleTime: 30_000,
  })
}
